module.exports = __webpack_public_path__ + "static/media/cocktail-home.c64aa0e5.png";